import { useState } from "react"
import { ModesComp } from "../../../Comps/ModesComp/ModesComp"
import { ChapterConfig } from "../../ChapterConfig"
import { ModalSpectrumV2 } from "../../../Comps/ModalSpectrum/ModalSpectrumV2"
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox"
import { FlexRowThree, FlexRowTwo } from "../../../Layouts/FlexRows"
import { Music } from "../../../Util/Music/Music"
import { ChapterNav, ChapterNavItem } from "../ChapterNav/ChapterNav"
import { ClearHelpers } from "../../Helpers/ClearHelpers/ClearHelpers"
import { Helpers } from "../../Helpers/Helpers"
import { ChapterRoutes } from "../ChapterNav/ChapterRoutes"
import { Menu, MenuItem, MenuRadioGroup } from "@szhsin/react-menu"
import { ModePositionsExercise } from "../../Exercises/ModePositionsExercise/ModePositionsExercise"
import { MenuArrow } from "../../../Comps/Menu/MenuDownArrow"
import { NotesSelectMenu } from "../../../Comps/NoteButtons/NotesSelect"

export function ModesChapter(props:ChapterConfig){

    const [tonic, setTonic] = useState(Music.C)
    const onTonicChange = (ton:number) => {
        setTonic(ton)
    }
    const subPaths:ChapterNavItem[] = [
        {   title:'Relative Modes',
            path:'relative_modes',              
            element:<ClearHelpers key={0}>
                        <RelativeModes tonic={tonic}/>
                    </ClearHelpers>},
        {   title:'Parallel Modes', 
            path:'parallel_modes', 
            element:<ClearHelpers key={1} openHelpers={[]}>
                        <ParallelModes tonic={tonic}/>
                    </ClearHelpers>},
        {   title:'The Modal Spectrum', 
            path:'modal_spectrum', 
            element:<ClearHelpers key={2} openHelpers={[]}>
                        <ModalSpectrum tonic={tonic}/>
                    </ClearHelpers>},{   title:'Modal Intervals', 
            path:'modal_intervals', 
            element:<ClearHelpers key={2} openHelpers={[]}>
                        <ModalIntervals tonic={tonic}/>
                    </ClearHelpers>},
        {   title:'Mode Position Exercise', 
            path:'mode_positions', 
            element:<ClearHelpers key={3} openHelpers={[Helpers.ModeNames]}>
                        <ModePositionsExercise tonic={tonic}/>
                    </ClearHelpers>}
    ]
    return  <div>
                <h1>The Modes : Seven Personalities of a Key</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <NotesSelectMenu tonic={tonic} onChange={onTonicChange}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
                            
}

export function RelativeModes(props:{tonic:number}){
    const [double, setDouble] = useState(false)

    const toggleDouble = () => {
        setDouble(!double)
    }
    const HexKeys = () => {
        if(double){
            return(
                <FlexRowTwo columnOneFlex={1} columnTwoFlex={1}>
                    <ModesComp tonic={props.tonic} key={0}/>
                    <ModesComp tonic={props.tonic} key={2}/>
                </FlexRowTwo>
            )
        }
        return (
            <ModesComp tonic={props.tonic} key={0}/>
        )
    }
    return(
        <div>
            <div style={{width:1400, margin:'auto', marginTop:50}}>
                <OutlineBox title={'Relative Modes: Modes in the same key'}>
                    <FlexRowTwo columnOneFlex={1} columnTwoFlex={1}>
                        <div>
                            <HexKeys/>
                            <button type={'button'} onClick={toggleDouble}>Side by Side</button>
                        </div>
                        <ModalSpectrumV2 tonic={props.tonic} relative={true}/>
                    </FlexRowTwo>
                </OutlineBox>
            </div>
        </div>
    )
}
export function ParallelModes(props:{tonic:number}){
    const modalTonics:any[] = [
        ['Ionian', (Music.C + props.tonic) % 12],
        ['Dorian', (Music.Bb + props.tonic) % 12],
        ['Phrygian', (Music.Ab + props.tonic) % 12],
        ['Lydian', (Music.G + props.tonic) % 12],
        ['Mixolydian', (Music.F + props.tonic) % 12],
        ['Aeolian', (Music.Eb + props.tonic) % 12],
        ['Locrian', (Music.Db + props.tonic) % 12],
    ]
    const [selectedMode, setSelectedMode] = useState(0)
    const onModeSelection = (e:any) => {
        setSelectedMode(e.value)
    }

    return(
            <div style={{width:1450, margin:'auto'}}>
                <OutlineBox title={'Parallel Modes: Modes with the same root, in different keys'}>
                    <FlexRowThree columnOneFlex={1} columnTwoFlex={1} columnThreeFlex={2}>
                        <ModesComp tonic={props.tonic} key={0}/>
                        <div>
                            <ModesComp tonic={modalTonics[selectedMode][1]} key={1}/>
                            <Menu menuButton={
                                    <button type='button'>Mode: {modalTonics[selectedMode][0]} <MenuArrow/></button>
                                }>
                                <MenuRadioGroup
                                        value={selectedMode}
                                        onRadioChange={onModeSelection}>
                                        {
                                            modalTonics.map((modalTonic:number[], index:number)=>{
                                                return(
                                                    <MenuItem type="radio" value={index}>{modalTonic[0]}</MenuItem>
                                                )
                                            })
                                        }
                                </MenuRadioGroup>
                            </Menu>
                        </div>
                        <ModalSpectrumV2 tonic={props.tonic} relative={false}/>
                    </FlexRowThree>
                </OutlineBox> 
            </div>
    )
}
export function ModalSpectrum(props:{tonic:number}){
    return(
            <div style={{width:1000, margin:'auto'}}>
                <OutlineBox title={'The Modal Spectrum'}>
                    <div style={{width:800, margin:'auto'}}>
                        <ModalSpectrumV2 useSpectrum={true} tonic={props.tonic} relative={false}/>
                    </div>
                </OutlineBox>
            </div>
    )
}
export function ModalIntervals(props:{tonic:number}){
    return(
            <div style={{width:1000, margin:'auto'}}>
                <OutlineBox title={'Modal Intervals'}>
                    <div style={{width:800, margin:'auto'}}>
                        <ModalSpectrumV2 useSpectrum={true} tonic={props.tonic} relative={false}/>
                    </div>
                </OutlineBox>
            </div>
    )
}